import React, { Component } from 'react'
import { connect } from 'redaction'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { snowplow, constants } from 'common/helpers'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import { Logo } from 'components/_new/ui'
import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import Countdown from 'components/ui/countdown/ActiveQueueCountdown/ActiveQueueCountdown'

import messages from './messages'
import s from './ThankYouQueueModal.scss'


class ThankYouQueueModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    isMale: PropTypes.bool,
    data: PropTypes.shape({
      redirectLink: PropTypes.string,
    }),
  }

  static defaultProps = {
    name: constants.modals.ThankYouQueue,
  }

  componentDidMount() {
    snowplow.track(constants.snowplowEvents.thankYouQueuePopup)
  }

  handleClick = () => {
    const { name, data: { redirectLink } } = this.props

    actions.models.modals.close(name)
    snowplow.track(constants.snowplowEvents.thankYouQueuePopupClick, {
      link: redirectLink,
    })
  }

  render() {
    const { name, isMale, onClose, data: { redirectLink } } = this.props

    return (
      <Modal
        className={s.thankYouQueueModal}
        name={name}
        fullWidth
        onClose={onClose}
      >
        <div className={s.container}>
          <Logo className={s.logo} dark />
          <div className={s.countdown}>
            <FormattedMessage {...messages.only} />
            <Countdown className={s.digits} withColons />
            <FormattedMessage {...messages.left} />
          </div>
          <FormattedHTMLMessage {...messages.textTop} values={{ isMale }} />
          <Button
            className={s.button}
            xlg
            title={isMale ? messages.buttonMen : messages.buttonWomen}
            to={redirectLink}
            brand
            onClick={this.handleClick}
          />
          <FormattedHTMLMessage {...messages.textBottom} values={{ isMale }} />
        </div>
      </Modal>
    )
  }
}


export default connect({
  isMale: (state) => state.models.me.gender === 'male',
})(ThankYouQueueModal)
